export const StatusIconeConvenioParceiro = {
    ATUALIZAR: 'edit',
    INSERIR: 'plus',
};
